import type { UndoableAction } from './undoable-action';

/** O aviso com Desfazer embaixo da tela: some sozinho em 10 s, e um novo toma o lugar do anterior. */
export class UndoOffer {
  private static readonly DURATION_MS = 10_000;

  current = $state<UndoableAction | null>(null);
  private timer: ReturnType<typeof setTimeout> | undefined;

  offer(action: UndoableAction): void {
    clearTimeout(this.timer);
    this.current = action;
    this.timer = setTimeout(() => (this.current = null), UndoOffer.DURATION_MS);
  }

  async revert(): Promise<void> {
    const revert = this.current?.revert;
    this.dismiss();
    if (!revert) return;
    await revert();
  }

  dismiss(): void {
    clearTimeout(this.timer);
    this.current = null;
  }
}
